import React from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

const ResetPasswordModal = ({
    show,
    onHide,
    onSubmit,
    loading = false,
    error = '',
    password = '',
    onPasswordChange,
    confirmPassword = '',
    onConfirmPasswordChange,
}) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton className="p-3 pb-0">
            <Modal.Title>Actualizar contraseña</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Ingresa tu nueva contraseña y confírmala para finalizar el proceso.</p>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={onSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Nueva contraseña</Form.Label>
                    <Form.Control
                        type="password"
                        value={password}
                        onChange={(e) => onPasswordChange?.(e.target.value)}
                        placeholder="Ingrese su nueva contraseña"
                        autoFocus
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Confirmar contraseña</Form.Label>
                    <Form.Control
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => onConfirmPasswordChange?.(e.target.value)}
                        placeholder="Confirme su nueva contraseña"
                    />
                </Form.Group>
                <div className="d-flex justify-content-end">
                    <Button variant="primary" type="submit" disabled={loading || !password || !confirmPassword}>
                        {loading ? 'Actualizando...' : 'Guardar contraseña'}
                    </Button>
                </div>
            </Form>
        </Modal.Body>
    </Modal>
);

export default ResetPasswordModal;
